export function requireNodeEnvVar(name: string): string {
  if (typeof process !== 'undefined') {
    const value = process.env[name];
    if (value === undefined) {
      throw new Error(`Env var ${name} is undefined`);
    } else {
      return value;
    }
  }else{
    const value = import.meta.env[`REACT_APP_${name}`];
    if (value === undefined) {
      if(name === "BACKEND_SERVICE_URL"){
        return "https://genmiq-data-services-894145150101.europe-west3.run.app"
      }
      throw new Error(`Env var ${name} is undefined`);
    } else {
      return value;
    }
  }

}
